import { useCurrentOfferId } from './useCurrentOfferId';
import { useCurrentPayLink } from './useCurrentPayLink';
import { useGetFormalOffers } from '../../../api/lending/lapiHooks';
import { TDuration } from '../../PayLinkLanding/utils/PayLinkLanding.types';
import { getDurationInMonths, productFromDuration } from '../../utils/product';

export function useInterestRate() {
  const { payLink } = useCurrentPayLink();
  const offerId = useCurrentOfferId();
  const { formalOffers } = useGetFormalOffers();

  const formalOffer = formalOffers?.formal_offers.find(
    (offer) => offer.offer_id === offerId,
  );

  const duration = formalOffer?.duration
    ? (getDurationInMonths(formalOffer.duration) as TDuration)
    : 3; // fall back to 3 months if the duration is not defined
  const product = productFromDuration[duration];

  const payLinkPricingInterest =
    payLink?.product_pricing?.[product]?.representative_interest;

  if (payLinkPricingInterest === 0) {
    return 0;
  }

  return formalOffer?.interest_rates?.[0].rate;
}
